// mobile-menu.js — Simplified version without submenus
const settings = {
  rootSelector: "#cbp-spmenu-s2",          // the slide-out menu container
  burgerSelector: ".burger",               // your <button class="burger" id="showRight">
  openClass: "open",                       // used on .burger
  menuOpenClass: "cbp-spmenu-open",        // used on #cbp-spmenu-s2
  bodyOpenClass: "mobile-menu-open",       // optional body lock class
};

const MobileMenu = {
  init() {
    //console.log("MobileMenu.init() called");
    const root = document.querySelector(settings.rootSelector);
    const burger = document.querySelector(settings.burgerSelector);
    //console.log("Root element found:", root);
   // console.log("Burger element found:", burger);
    if (!root) {
      //console.log("No root element found, exiting");
      return;
    }

    // ---------- Burger open/close ----------
    const openMenu = () => {
      root.classList.add(settings.menuOpenClass);
      document.body.classList.add(settings.bodyOpenClass);
      if (burger) burger.classList.add(settings.openClass);
    };
    const closeMenu = () => {
      //console.log("closeMenu called");
      root.classList.remove(settings.menuOpenClass);
      document.body.classList.remove(settings.bodyOpenClass);
      if (burger) burger.classList.remove(settings.openClass);
      //console.log("Menu should be closed now");
    };
    const toggleMenu = () => {
      if (root.classList.contains(settings.menuOpenClass)) closeMenu();
      else openMenu();
    };

    if (burger) {
      const onBurger = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        toggleMenu();
      };
      // Use pointerup for reliable taps; fall back to touchend/click
      if (window.PointerEvent) {
        burger.addEventListener("pointerup", onBurger);
      } else {
        burger.addEventListener("touchend", onBurger, { passive: false });
        burger.addEventListener("click", onBurger);
      }
    }

    // ---------- Menu item clicks close the menu ----------
    // Use document-level delegation to bypass any event blocking
    document.addEventListener("click", (e) => {
      // Only handle clicks on links inside the mobile menu
      if (root.contains(e.target)) {
        const link = e.target.closest("a");
        if (link && root.contains(link)) {
          //console.log("Document-level: Menu link clicked", link);
          closeMenu();
          // Don't prevent default - let the link work normally
        }
      }
    }, true); // Use capture phase to get events before they're potentially blocked
    //console.log("Document-level event listener attached for menu links");

    // ---------- Outside click closes whole menu ----------
    document.addEventListener("click", (e) => {
      if (burger && (e.target === burger || burger.contains(e.target))) return; // don't immediately close after tapping burger
      if (!root.contains(e.target)) {
        closeMenu(); // Only close if click is outside the menu
      }
    });

    // ---------- Esc closes whole menu ----------
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeMenu();
    });
  },
};

export default MobileMenu;
